import { auth } from './firebase';

const API_BASE = process.env.REACT_APP_API_URL || 'https://levare-platform.onrender.com';

export async function apiPost(path, body) {
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  const idToken = await user.getIdToken();
  const res = await fetch(API_BASE + path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`
    },
    body: JSON.stringify(body)
  });
  if (res.status === 429) throw new Error('RATE_LIMIT');
  if (res.status === 401) throw new Error('UNAUTHORISED');
  if (!res.ok) throw new Error('Server error ' + res.status);
  return res.json();
}
